/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ContactSubmissionRecord interface.
 */
export function instanceOfContactSubmissionRecord(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('subject' in value) || value['subject'] === undefined)
        return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined)
        return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function ContactSubmissionRecordFromJSON(json) {
    return ContactSubmissionRecordFromJSONTyped(json, false);
}
export function ContactSubmissionRecordFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brand': json['brand'] == null ? undefined : json['brand'],
        'email': json['email'],
        'message': json['message'],
        'name': json['name'],
        'subject': json['subject'],
        'submissionId': json['submission_id'],
        'timestamp': (new Date(json['timestamp'])),
        'type': json['type'],
    };
}
export function ContactSubmissionRecordToJSON(json) {
    return ContactSubmissionRecordToJSONTyped(json, false);
}
export function ContactSubmissionRecordToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brand': value['brand'],
        'email': value['email'],
        'message': value['message'],
        'name': value['name'],
        'subject': value['subject'],
        'submission_id': value['submissionId'],
        'timestamp': value['timestamp'].toISOString(),
        'type': value['type'],
    };
}
